import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TextSearchService } from 'src/app/services/text-search.service';
import { DescriptionModalRasComponent } from './description-modal-ras/description-modal-ras.component';

@Component({
  selector: 'search-ras-content',
  templateUrl: './search-ras-content.component.html',
  styleUrls: ['./search-ras-content.component.scss'],
})
export class SearchRasContentComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;
  displayedColumns: string[] = [
    'gai',
    'caseType',
    'description',
    'assing',
    'lastModification',
    'type',
  ];
  displayedColumnsTask: string[] = [
    'task',
    'icase',
    'lastModification',
    'state',
    'type',
  ];
  dataSource: MatTableDataSource<any>;
  option;
  cases;
  task;
  constructor(
    public readonly textSearchService: TextSearchService,
    private readonly router: Router,
    private readonly dialog: MatDialog
  ) {}

  ngOnInit() {
    this.textSearchService.changeType.subscribe((v: any) => {
      this.option = v;
      if (v == 'Casos') {
        this.setData(this.cases);
      } else if (v == 'Tareas') {
        this.setData(this.task);
      }
    });
    this.textSearchService.dataToContent.subscribe((v: any) => {
      this.option = v.option;
      this.cases = v.cases;
      this.task = v.task;
      if (v.option == 'Casos') {
        this.setData(v.cases);
      } else if (v.option == 'Tareas') {
        this.setData(v.task);
      }
      // else {
      //   this.setData([...v.cases, ...v.task]);
      // }
      // this.setData(this.cases);
    });
  }

  returnState(v) {
    switch (v) {
      case 'pending':
        return 'Pendiente de realizar';
        break;
      case 'running':
        return 'En ejecución';
        break;
      case 'finished':
        return 'Finalizada';
        break;
      default:
        break;
    }
  }
  seeCase(id) {
    this.router.navigate([`/caseRas/${id}`]);
  }
  alert(title: string, description) {
    this.dialog.open(DescriptionModalRasComponent, {
      data: { title, description },
      height: '260px',
      width: '610px',
      maxHeight: '300px',
      disableClose: true,
      panelClass: 'class-ras-border',
    });
  }
  setData(data: any[]) {
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
  }
}
